module.exports = __webpack_public_path__ + "media/images/frontend/de-7bd8b2496e2b08ad3d435155583e0d79.png";